import styled from '@emotion/styled';
import { Modal, Button } from 'semantic-ui-react';
import { renderAnswers } from 'src/components/helpers/renderFormAnswers';
import { prestadores_evaluacion_questions } from './quiz/prestadores_evaluacion_questions';

const StyledModalHeader = styled(Modal.Header)`
  font-size: 20px;
  font-weight: 600;
`;

const StyledModalContent = styled(Modal.Content)`
  padding: 2rem;

  .user-info-container {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    padding: 1.5rem;
    border-radius: 8px;
    margin-bottom: 2rem;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }

  .user-info-text {
    margin: 0.5rem 0;
    font-size: 15px;
    line-height: 1.6;
  }

  .user-info-label {
    display: inline-block;
    min-width: 120px;
  }

  .results-container {
    padding: 0;
  }

  .answers-wrapper {
    padding: 0;

    .question {
      padding: 10px 0;

      h2 {
        color: #2c3e50;
        font-size: 24px;
        font-weight: 600;
        margin: 0 0 1rem 0;
        padding-bottom: 0.75rem;
        border-bottom: 2px solid #e9ecef;
      }

      h3 {
        color: #34495e;
        font-size: 20px;
        font-weight: 600;
        margin: 0 0 10px 0;
        border-bottom: 2px solid #e9ecef;
      }

      p {
        color: #495057;
        font-size: 16px;
        line-height: 1.6;
        margin: 0.5rem 0;
      }

      .answer {
        background: #f8f9fa;
        border-left: 4px solid #3498db;
        padding: 1rem 1.25rem;
        margin-top: 0.75rem;
        border-radius: 4px;
        color: #2c3e50;
        font-size: 15px;
        line-height: 1.6;
        font-weight: 500;
      }

      .section-title {
        padding: 1rem 1.5rem;

        h2 {
          color: white;
          border: none;
          padding: 0;
          margin: 0;
        }
      }

      .section-subtitle {
        color: #6c757d;
        font-size: 18px;
        font-weight: 500;
        margin-bottom: 1rem;

        h3 {
          color: #6c757d;
          border: none;
          padding: 0;
          margin: 0;
          font-size: 18px;
        }
      }

      .intro-text {
        background: #f8f9fa;
        padding: 1rem;
        border-radius: 6px;
        margin-bottom: 1rem;
        border-left: 3px solid #3498db;

        p {
          color: #495057;
          margin: 0.5rem 0;
        }
      }
    }
  }

  .empty-state-container {
    text-align: center;
    padding: 3rem;
    color: #6c757d;
    font-size: 16px;
  }
`;

const QuizResultsModal = ({ open, onClose, user, entry, interaction }) => {
  if (!interaction || !interaction.content) {
    return null;
  }

  const answers = interaction.content.answers || {};
  let questions = [];

  // Get questions based on entry content type
  if (entry.content === 'prestadores_evaluacion') {
    questions = prestadores_evaluacion_questions(answers);
  }

  return (
    <Modal open={open} onClose={onClose} size="large">
      <StyledModalHeader>Resultados de la encuesta - {user?.name || 'Usuario'}</StyledModalHeader>
      <StyledModalContent scrolling>
        <div className="user-info-container">
          <p className="user-info-text">
            <strong className="user-info-label">Usuario:</strong>
            {user?.name || 'Sin nombre'} ({user?.email || 'Sin email'})
          </p>
          <p className="user-info-text">
            <strong className="user-info-label">Fecha de envío:</strong>
            {interaction.createdAt
              ? new Date(interaction.createdAt).toLocaleString('es-ES')
              : 'N/A'}
          </p>
        </div>
        <div className="results-container">
          {questions.length > 0 ? (
            <div className="answers-wrapper">{renderAnswers(questions, answers)}</div>
          ) : (
            <div className="empty-state-container">
              <p>No hay preguntas disponibles para este tipo de encuesta.</p>
            </div>
          )}
        </div>
      </StyledModalContent>
      <Modal.Actions>
        <Button onClick={onClose} primary>
          Cerrar
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default QuizResultsModal;
